<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="pi_inoutno,pi_custname,pi_remark"
      placeholder="输入单据编号、客户、备注进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/sale/out/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.pi_custname}}</p>
          <p class="list-item-muted">{{item.pi_inoutno}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'¥#,##0.00'">{{item.pi_total}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.pi_status!='已审核'}"
          >{{item.pi_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}笔</label>
      <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('pi_total')}}</em>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/sale/prodinout/list",
      filters: [
        {
          type: "date",
          name: "pi_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
              condition: "pi_class='SALEOUT'"
            },
            {
              value: 1,
              label: "待发货",
              condition: "pi_class='SALEOUT' and pi_status='未审核'"
            },
            {
              value: 2,
              label: "待对账",
              condition:
                "pi_status='已审核' and pi_class in('出货单','销售退货单','SALEOUT','SALERETURN') and IFNULL(Apcheckstatus,' ') != '已对账' and pd_status = 99 ",
              mode: "DETAIL"
            },
            {
              value: 3,
              label: "待收款",
              condition:
                "pi_status='已审核' and pi_class in('出货单','销售退货单','SALEOUT','SALERETURN') and exists(select 1 from prodiodetail b where pi_id=b.pd_piid and ifnull(pd_ordertotal,0)>ifnull(pd_recamount,0)) "
            },
            {
              value: 4,
              label: "已出货",
              condition: "pi_class='SALEOUT' and pi_status='已审核'"
            },
            {
              value: 5,
              label: "已收款",
              condition: "pi_class='SALEOUT' and pi_prstatus='已收款'"
            }
          ]
        }
      ]
    };
  }
};
</script>